import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { IApplicationState } from './store/ApplicationState';
import configureStore from './configureStore';
// import createHistory from 'history/createBrowserHistory'
import { createBrowserHistory } from "history";
import { ConnectedRouter } from 'connected-react-router';
import { Auth0Provider } from "./common/Auth0/react-auth0-spa";
import { CircularProgress } from '@material-ui/core';

const history = createBrowserHistory();
const initialState = (window as any).initialReduxState as IApplicationState;
const store = configureStore(history, initialState);


const onRedirectCallback = appState => {
    history.push(
        appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
    );
};
interface Initresponse {
    domain: string;
    clientId: string;
}
const Index = () => {
    const [auth0Params, setAuth0Params] = React.useState<Initresponse>();
    React.useEffect(() => {
        // debugger
        fetch('/api/init').then(async resp => {
            const pars = await resp.json();
            setAuth0Params(pars);
        })
    }, [])
    if (!auth0Params)
        return <CircularProgress />
    else
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Auth0Provider
                        initOptions={{
                            domain: auth0Params.domain,
                            client_id: auth0Params.clientId,
                            redirect_uri: window.location.origin,
                        }}
                        onRedirectCallback={onRedirectCallback}
                    >      <App />
                    </Auth0Provider>
                </ConnectedRouter>
            </Provider >
        );
}
ReactDOM.render(
    <Index />
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
